// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../graphql/api/index';

import { BlockFragmentDoc } from '../../../../components/cms/CmsBlock.fragment.generated';
import { BlockAnchorFragmentDoc } from '../../../../components/cms/BlockAnchor.fragment.generated';
import { ComponentFragmentDoc } from '../../../../components/cms/CmsComponent.fragment.generated';
import { ComponentsFragmentDoc } from '../../../../components/cms/component.generated';
import { ComponentRoundedImageFragmentDoc } from '../../../../components/cms/component/ComponentRoundedImage.fragment.generated';
import { CmsImageSizesFragmentDoc } from '../../../../components/cms/cmsImageSizes.fragment.generated';
import { ImageCommonFragmentDoc } from '../../../../components/cms/imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../../../components/cms/imageSize.fragment.generated';
import { ComponentRoundedImageContentFragmentDoc } from '../../../../components/cms/component/ComponentRoundedImageContent.fragment.generated';
import { ContentComponentItemFragmentDoc } from '../../../../components/cms/component/ContentComponentItem.fragment.generated';
import { ComponentTitleFragmentDoc } from '../../../../components/cms/component/content/ContentTitle.fragment.generated';
import { ComponentTitleComponentFragmentDoc } from '../../../../components/cms/component/content/componentTitleComponent.fragment.generated';
import { ComponentTitleAmpersandFragmentDoc } from '../../../../components/cms/component/content/componentTitleAmpersand.fragment.generated';
import { ComponentTitleTextFragmentDoc } from '../../../../components/cms/component/content/componentTitleText.fragment.generated';
import { ComponentTextFragmentDoc } from '../../../../components/cms/component/content/ContentText.fragment.generated';
import { ComponentButtonFragmentDoc } from '../../../../components/cms/component/content/ContentButton.fragment.generated';
import { LinkFragmentDoc, LinkItemFragmentDoc, PageLinkFragmentDoc, PostLinkFragmentDoc, CustomLinkFragmentDoc, LinkQuestionnaireFragmentDoc, LinkItemOpenEnquiryFormFragmentDoc, LinkItemErRecommendationsFragmentDoc } from '../../../../components/cms/index.generated';
import { ComponentSpacerFragmentDoc } from '../../../../components/cms/component/content/ContentSpacer.fragment.generated';
import { ComponentImageFragmentDoc } from '../../../../components/cms/component/content/ContentImage.fragment.generated';
import { ComponentOrderedListFragmentDoc } from '../../../../components/cms/component/content/ContentOrderedList.fragment.generated';
import { OrderedListItemFragmentDoc } from '../../../../components/cms/component/content/orderedListItem.generated';
import { ComponentContentFragmentDoc } from '../../../../components/cms/component/ComponentContent.fragment.generated';
import { ComponentCardFragmentDoc } from '../../../../components/cms/component/CardComponent.fragment.generated';
import { ComponentTextOverImageFragmentDoc } from '../../../../components/cms/component/ComponentTextOverImage.fragment.generated';
import { ComponentCustomProductCarouselFragmentDoc } from '../../../../components/cms/component/ComponentCustomProductCarousel.fragment.generated';
import { CustomProductCarouselCardFragmentDoc } from '../../../../components/cms/component/carousel/card/CustomProductCarouselCard.fragment.generated';
import { ComponentCatalogueProductCarouselFragmentDoc } from '../../../../components/cms/component/ComponentCatalogueProductCarousel.fragment.generated';
import { ProductCardFragmentDoc } from '../../../../components/layout/cards/ProductCard.fragment.generated';
import { ProductLinkFragmentDoc } from '../../../../router/fragments/productLink.fragment.generated';
import { EngagementRingLinkFragmentDoc } from '../../../../router/fragments/engagementRingLink.fragment.generated';
import { JewelleryLinkFragmentDoc } from '../../../../router/fragments/jewelleryLink.fragment.generated';
import { ReadyToGoRingLinkFragmentDoc } from '../../../../router/fragments/readyToGoRingLink.fragment.generated';
import { WeddingRingLinkFragmentDoc } from '../../../../router/fragments/weddingRingLink.fragment.generated';
import { MetalVariationFragmentDoc } from '../../../../components/rings/MetalVariations.generated';
import { MetalFilterMetalFragmentDoc } from '../../../../graphql/api/product/rings/fragments/filters/metalFilter.fragment.generated';
import { GetIsLabGrownFragmentDoc } from '../../../../domain/product/getIsLabGrown.generated';
import { MoneyFragmentDoc } from '../../../../graphql/api/fragments/money.fragment.generated';
import { MonolithImageSizeFragmentDoc } from '../../../../components/monolithImageSize.fragment.generated';
import { ComponentReviewCarouselFragmentDoc } from '../../../../components/cms/component/ComponentReviewCarousel.fragment.generated';
import { ComponentMainCoverFragmentDoc } from '../../../../components/cms/component/ComponentMainCover.fragment.generated';
import { VideoFragmentDoc } from '../../../../components/cms/video.fragment.generated';
import { ComponentVideoFragmentDoc } from '../../../../components/cms/component/ComponentVideo.fragment.generated';
import { ComponentVideoWithContentFragmentDoc } from '../../../../components/cms/component/ComponentVideoWithContent.fragment.generated';
import { ComponentInstagramPostsFragmentDoc } from '../../../../components/cms/component/ComponentInstagramPosts.fragment.generated';
import { ComponentLogosFragmentDoc } from '../../../../components/cms/component/ComponentLogos.fragment.generated';
import { ComponentLogosCarouselFragmentDoc } from '../../../../components/cms/component/ComponentLogosCarousel.fragment.generated';
import { ComponentTextWithImageFragmentDoc } from '../../../../components/cms/component/ComponentTextWithImage.fragment.generated';
import { ComponentGalleryCarouselFragmentDoc } from '../../../../components/cms/component/ComponentGalleryCarousel.fragment.generated';
import { GalleryCarouselCardFragmentDoc } from '../../../../components/cms/component/carousel/card/GalleryCarouselCard.fragment.generated';
import { ComponentCardCarouselFragmentDoc } from '../../../../components/cms/component/carousel/card/ComponentCardCarousel.fragment.generated';
import { CardCarouselCardFragmentDoc } from '../../../../components/cms/component/carousel/card/CardCarouselCard.fragment.generated';
import { ComponentFullWidthImageFragmentDoc } from '../../../../components/cms/component/ComponentFullWidthImage.fragment.generated';
import { ComponentSideBySideImagesFragmentDoc } from '../../../../components/cms/component/ComponentSideBySideImages.fragment.generated';
import { ComponentSideBySideImageFragmentDoc } from '../../../../components/cms/component/side-by-side-images/ComponentSideBySideImage.fragment.generated';
import { ComponentArticlePreviewsFragmentDoc } from '../../../../components/cms/component/ComponentArticlePreviews.fragment.generated';
import { ArticlePreviewFragmentDoc } from '../../../../components/cms/component/article-previews/ArticlePreview.fragment.generated';
import { ComponentInstagramWithContentFragmentDoc } from '../../../../components/cms/component/ComponentInstagramWithContent.fragment.generated';
import { ComponentBannerTitleFragmentDoc } from '../../../../components/cms/component/ComponentBannerTitle.fragment.generated';
import { ComponentQuoteFragmentDoc } from '../../../../components/cms/component/ComponentQuote.fragment.generated';
import { ComponentBannerSkinnyFragmentDoc } from '../../../../components/cms/component/ComponentBannerSkinny.fragment.generated';
import { ComponentGlobalSpacerFragmentDoc } from '../../../../components/cms/component/ComponentGlobalSpacer.fragment.generated';
import { ComponentTextWithImageCarouselFragmentDoc } from '../../../../components/cms/component/ComponentTextWithImageCarousel.fragment.generated';
import { ComponentContentWithGalleryFragmentDoc } from '../../../../components/cms/component/ComponentContentWithGallery.fragment.generated';
import { ComponentIconCarouselFragmentDoc } from '../../../../components/cms/component/ComponentIconCarousel.fragment.generated';
import { ComponentTextCarouselFragmentDoc } from '../../../../components/cms/component/ComponentTextCarousel.fragment.generated';
import { ComponentFaqFragmentDoc } from '../../../../components/cms/component/ComponentFaq.fragment.generated';
import { FaqSectionFragmentDoc } from '../../../../components/cms/component/faq/FaqSection.fragment.generated';
import { FaqQuestionFragmentDoc } from '../../../../components/cms/component/faq/FaqQuestion.fragment.generated';
import { ComponentBenefitsAccordionFragmentDoc } from '../../../../components/cms/component/benefits-accordion/ComponentBenefitsAccordion.fragment.generated';
import { BenefitsAccordionRowFragmentDoc } from '../../../../components/cms/component/benefits-accordion/BenefitsAccordionRow.fragment.generated';
import { ComponentContentTwoColumnsFragmentDoc } from '../../../../components/cms/component/ComponentContentTwoColumns.fragment.generated';
import { ComponentTableFragmentDoc } from '../../../../components/cms/component/ComponentTable.fragment.generated';
import { ComponentArticleGridFragmentDoc } from '../../../../components/cms/component/ComponentArticleGrid.fragment.generated';
import { ArticleGridItemFragmentDoc } from '../../../../components/cms/component/article-grid/ArticleGridItem.fragment.generated';
import { ComponentOnThisPageFragmentDoc } from '../../../../components/cms/component/ComponentOnThisPage.fragment.generated';
import { ComponentGalleryWithEnquiryFragmentDoc } from '../../../../components/cms/component/gallery-with-enquiry/componentGalleryWithEnquiry.fragment.generated';
import { GalleryWithEnquiryCardFragmentDoc } from '../../../../components/cms/component/gallery-with-enquiry/galleryWithEnquiryCard.fragment.generated';
import { ComponentSquareBoxesFragmentDoc } from '../../../../components/cms/component/square-boxes/ComponentSquareBoxes.fragment.generated';
import { SquareBoxesFragmentDoc } from '../../../../components/cms/component/square-boxes/squareBoxes.fragment.generated';
import { SquareTextBoxFragmentDoc } from '../../../../components/cms/component/square-boxes/SquareTextBox.fragment.generated';
import { SquareImageBoxFragmentDoc } from '../../../../components/cms/component/square-boxes/SquareImageBox.fragment.generated';
import { ComponentShopWithConfidenceFragmentDoc } from '../../../../components/cms/component/ComponentShopWithConfidence.generated';
import { ComponentWarrantyActivationFormFragmentDoc } from '../../../../components/cms/component/ComponentWarrantyActivationForm.fragment.generated';
import { ComponentJobsFragmentDoc } from '../../../../components/cms/component/ComponentJobs.fragment.generated';
import { ComponentJobsJobFragmentDoc } from '../../../../components/cms/component/ComponentJobsJob.fragment.generated';
import { ComponentLogosWithTextFragmentDoc, LogoWithTextFragmentDoc } from '../../../../components/cms/component/ComponentLogosWithText.fragment.generated';
import { ComponentGlobalComponentFragmentDoc } from '../../../../components/cms/component/ComponentGlobalComponent.fragment.generated';
import { EngagementRingStoneRecommendationCardFragmentDoc } from './engagementRingStoneRecommendationCard.fragment.generated';
import { StoneFragmentDoc } from '../../../../graphql/api/stone/gems/fragments/stone.fragment.generated';
import { StoneCategoryFragmentDoc } from '../../../../graphql/api/stone/gems/fragments/StoneCategory.fragment.generated';
import { StoneCategoryTranslationFragmentDoc } from '../../../../graphql/api/stone/gems/fragments/StoneCategoryTranslation.fragment.generated';
import { StoneClarityFragmentDoc } from '../../../../graphql/api/stone/gems/fragments/stoneClarity.fragment.generated';
import { ClarityTranslationFragmentDoc } from '../../../../graphql/api/stone/gems/fragments/ClarityTranslation.fragment.generated';
import { StoneColorFragmentDoc } from '../../../../graphql/api/stone/gems/fragments/StoneColor.fragment.generated';
import { StoneColorTranslationFragmentDoc } from '../../../../graphql/api/stone/gems/fragments/StoneColorTranslation.fragment.generated';
import { StoneCrystalFragmentDoc } from '../../../../graphql/api/stone/nonsku/fragments/stoneCrystal.fragment.generated';
import { StoneCrystalTranslationFragmentDoc } from '../../../../graphql/api/stone/nonsku/fragments/stoneCrystalTranslation.fragment.generated';
import { StoneImageFragmentDoc } from '../../../../graphql/api/stone/gems/fragments/image.fragment.generated';
import { GemsApiCertificateFragmentDoc } from '../../../../domain/stone/certificate.generated';
import { StoneRecommendationsNotFoundFragmentDoc } from '../../../../graphql/api/stone/gems/fragments/stoneRecommendationsNotFound.fragment.generated';
import { NonSkuLabGrownFragmentDoc } from '../../../../graphql/api/stone/nonsku/fragments/nonSkuLabGrown.fragment.generated';
import { StoneShapeFragmentDoc } from '../../../../graphql/api/stone/nonsku/fragments/stoneShape.fragment.generated';
import { AssetFragmentDoc } from '../../../../graphql/api/fragments/asset.fragment.generated';
import { StoneShapeTranslationFragmentDoc } from '../../../../graphql/api/stone/nonsku/fragments/stoneShapeTranslation.fragment.generated';
import { NonSkuLabGrownStoneImageFragmentDoc } from '../../../../domain/stone/nonSkuLabGrownStoneImage.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export const StoneRecommendationGemsApiGemstoneFragmentDoc = `
    fragment stoneRecommendationGemsApiGemstone on StoneRecommendationGemsApiGemstone {
  color {
    systemCode
    translation(locale: $locale) {
      name
    }
  }
  stone {
    ... on GemsApi_Stone {
      ...stone
    }
    ... on StoneRecommendationNotFound {
      ...stoneRecommendationsNotFound
    }
  }
}
    `;
export const StoneRecommendationsFragmentDoc = `
    fragment stoneRecommendations on StoneRecommendationsResponse {
  ... on StoneRecommendationsResponseSuccess {
    priceBounds {
      min {
        ...money
      }
      max {
        ...money
      }
    }
    priceInitialValues @skip(if: $hasPrice) {
      min {
        ...money
      }
      max {
        ...money
      }
    }
    naturalDiamondBestForBalance {
      ... on GemsApi_Stone {
        ...stone
      }
      ... on StoneRecommendationNotFound {
        ...stoneRecommendationsNotFound
      }
    }
    naturalDiamondBestForSize {
      ... on GemsApi_Stone {
        ...stone
      }
      ... on StoneRecommendationNotFound {
        ...stoneRecommendationsNotFound
      }
    }
    skuGemStones {
      ...stoneRecommendationGemsApiGemstone
    }
    nonSkuLabGrownBestForPrice {
      ... on NonSkuLabGrown {
        ...nonSkuLabGrown
      }
      ... on StoneRecommendationNotFound {
        ...stoneRecommendationsNotFound
      }
    }
    nonSkuLabGrownBestForSize {
      ... on NonSkuLabGrown {
        ...nonSkuLabGrown
      }
      ... on StoneRecommendationNotFound {
        ...stoneRecommendationsNotFound
      }
    }
  }
  ... on StoneRecommendationsResponseFailure {
    error
  }
}
    `;
export const RingBuilderStoneRecommendationsFragmentDoc = `
    fragment ringBuilderStoneRecommendations on RingBuilderFragment {
  __typename
  ... on RingBuilderMountFragment {
    id
    stoneRecommendations(
      minPrice: $minPrice
      maxPrice: $maxPrice
      country: $country
      currency: $currency
    ) {
      __typename
      ...stoneRecommendations
    }
  }
  ... on RingBuilderCentreStoneFragment {
    id
  }
}
    `;
export const StoneRecommendationsDocument = `
    query stoneRecommendations($minPrice: MoneyInput, $maxPrice: MoneyInput, $locale: Locale!, $currency: CurrencyInput!, $country: CountryCode!, $hasPrice: Boolean!) {
  ringBuilder {
    __typename
    id
    position1 {
      ...ringBuilderStoneRecommendations
    }
    position2 {
      ...ringBuilderStoneRecommendations
    }
  }
  cms: engagementRingStoneRecommendations(locale: $locale) {
    __typename
    fullSearchButtonText
    blocks {
      ...block
    }
    naturalDiamonds {
      forSizeCard {
        ...engagementRingStoneRecommendationCard
      }
      forBalanceCard {
        ...engagementRingStoneRecommendationCard
      }
      labGrownAlternative {
        ...engagementRingStoneRecommendationCard
      }
    }
    nonSkuLabGrown {
      forSizeCard {
        ...engagementRingStoneRecommendationCard
      }
      forPriceCard {
        ...engagementRingStoneRecommendationCard
      }
      naturalDiamondAlternative {
        ...engagementRingStoneRecommendationCard
      }
    }
    nonSkuGemStones {
      content {
        ...engagementRingStoneRecommendationCard
      }
      color
    }
  }
}
    ${RingBuilderStoneRecommendationsFragmentDoc}
${StoneRecommendationsFragmentDoc}
${MoneyFragmentDoc}
${StoneFragmentDoc}
${StoneCategoryFragmentDoc}
${StoneCategoryTranslationFragmentDoc}
${StoneClarityFragmentDoc}
${ClarityTranslationFragmentDoc}
${StoneColorFragmentDoc}
${StoneColorTranslationFragmentDoc}
${StoneCrystalFragmentDoc}
${StoneCrystalTranslationFragmentDoc}
${MonolithImageSizeFragmentDoc}
${StoneImageFragmentDoc}
${GemsApiCertificateFragmentDoc}
${StoneRecommendationsNotFoundFragmentDoc}
${StoneRecommendationGemsApiGemstoneFragmentDoc}
${NonSkuLabGrownFragmentDoc}
${StoneShapeFragmentDoc}
${AssetFragmentDoc}
${StoneShapeTranslationFragmentDoc}
${NonSkuLabGrownStoneImageFragmentDoc}
${BlockFragmentDoc}
${BlockAnchorFragmentDoc}
${ComponentFragmentDoc}
${ComponentsFragmentDoc}
${ComponentRoundedImageFragmentDoc}
${CmsImageSizesFragmentDoc}
${ImageCommonFragmentDoc}
${ImageSizeFragmentDoc}
${ComponentRoundedImageContentFragmentDoc}
${ContentComponentItemFragmentDoc}
${ComponentTitleFragmentDoc}
${ComponentTitleComponentFragmentDoc}
${ComponentTitleAmpersandFragmentDoc}
${ComponentTitleTextFragmentDoc}
${ComponentTextFragmentDoc}
${ComponentButtonFragmentDoc}
${LinkFragmentDoc}
${LinkItemFragmentDoc}
${PageLinkFragmentDoc}
${PostLinkFragmentDoc}
${CustomLinkFragmentDoc}
${LinkQuestionnaireFragmentDoc}
${LinkItemOpenEnquiryFormFragmentDoc}
${LinkItemErRecommendationsFragmentDoc}
${ComponentSpacerFragmentDoc}
${ComponentImageFragmentDoc}
${ComponentOrderedListFragmentDoc}
${OrderedListItemFragmentDoc}
${ComponentContentFragmentDoc}
${ComponentCardFragmentDoc}
${ComponentTextOverImageFragmentDoc}
${ComponentCustomProductCarouselFragmentDoc}
${CustomProductCarouselCardFragmentDoc}
${ComponentCatalogueProductCarouselFragmentDoc}
${ProductCardFragmentDoc}
${ProductLinkFragmentDoc}
${EngagementRingLinkFragmentDoc}
${JewelleryLinkFragmentDoc}
${ReadyToGoRingLinkFragmentDoc}
${WeddingRingLinkFragmentDoc}
${MetalVariationFragmentDoc}
${MetalFilterMetalFragmentDoc}
${GetIsLabGrownFragmentDoc}
${ComponentReviewCarouselFragmentDoc}
${ComponentMainCoverFragmentDoc}
${VideoFragmentDoc}
${ComponentVideoFragmentDoc}
${ComponentVideoWithContentFragmentDoc}
${ComponentInstagramPostsFragmentDoc}
${ComponentLogosFragmentDoc}
${ComponentLogosCarouselFragmentDoc}
${ComponentTextWithImageFragmentDoc}
${ComponentGalleryCarouselFragmentDoc}
${GalleryCarouselCardFragmentDoc}
${ComponentCardCarouselFragmentDoc}
${CardCarouselCardFragmentDoc}
${ComponentFullWidthImageFragmentDoc}
${ComponentSideBySideImagesFragmentDoc}
${ComponentSideBySideImageFragmentDoc}
${ComponentArticlePreviewsFragmentDoc}
${ArticlePreviewFragmentDoc}
${ComponentInstagramWithContentFragmentDoc}
${ComponentBannerTitleFragmentDoc}
${ComponentQuoteFragmentDoc}
${ComponentBannerSkinnyFragmentDoc}
${ComponentGlobalSpacerFragmentDoc}
${ComponentTextWithImageCarouselFragmentDoc}
${ComponentContentWithGalleryFragmentDoc}
${ComponentIconCarouselFragmentDoc}
${ComponentTextCarouselFragmentDoc}
${ComponentFaqFragmentDoc}
${FaqSectionFragmentDoc}
${FaqQuestionFragmentDoc}
${ComponentBenefitsAccordionFragmentDoc}
${BenefitsAccordionRowFragmentDoc}
${ComponentContentTwoColumnsFragmentDoc}
${ComponentTableFragmentDoc}
${ComponentArticleGridFragmentDoc}
${ArticleGridItemFragmentDoc}
${ComponentOnThisPageFragmentDoc}
${ComponentGalleryWithEnquiryFragmentDoc}
${GalleryWithEnquiryCardFragmentDoc}
${ComponentSquareBoxesFragmentDoc}
${SquareBoxesFragmentDoc}
${SquareTextBoxFragmentDoc}
${SquareImageBoxFragmentDoc}
${ComponentShopWithConfidenceFragmentDoc}
${ComponentWarrantyActivationFormFragmentDoc}
${ComponentJobsFragmentDoc}
${ComponentJobsJobFragmentDoc}
${ComponentLogosWithTextFragmentDoc}
${LogoWithTextFragmentDoc}
${ComponentGlobalComponentFragmentDoc}
${EngagementRingStoneRecommendationCardFragmentDoc}`;

export function useStoneRecommendationsQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.StoneRecommendationsQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.StoneRecommendationsQuery, SchemaTypes.StoneRecommendationsQueryVariables | undefined>({ query: StoneRecommendationsDocument, variables: undefined, ...options });
};